import { useCallback } from "react";
import { useEffectOnce } from "react-use";
import { LoadingPage } from "components";
import { useSelector } from "redux/hooks";

import { useAppNotification } from "hooks/services/AppNotification";

import useRouter from "hooks/useRouter";

import { autoLoginFromTool, setStorageToolOrigin } from "redux/actions";
import { RoutePaths } from "pages/routePaths";

// Tool website address collection
export const toolRedirectURLs: { [key: string]: string; imageTool: string } = {
  imageTool: process.env.REACT_APP_IMAGE_TOOL_WEBSITE || "",
};

//Available tool origins
const acceptOrigin: string[] = ["imageTool"];

// Carry the Google authorized login response from the tool and enter the DeftGPT webapp to avoid users logging in again
export const AutomaticLoginPage = () => {
  const { query, push } = useRouter();
  const { triggerNotification } = useAppNotification();

  const { userDetail } = useSelector((state) => state.authReducer);
  const lang = userDetail?.user?.language ? userDetail?.user?.language : "en";

  const onAcceptQuery = useCallback(() => {
    if (
      Object.keys(query).length > 0 &&
      query.data &&
      acceptOrigin.includes(query.origin)
    ) {
      try {
        if (query?.origin) {
          setStorageToolOrigin(query.origin);
        }

        const loginResponse = JSON.parse(query.data);
        autoLoginFromTool(loginResponse);
        push(`/${RoutePaths.Settings}/${RoutePaths.CurrentPlan}`);
      } catch (error) {
        triggerNotification({
          message: "Oops, something went wrong, please log in again",
          type: "error",
        });
        push(`/${lang}/${RoutePaths.Login}`);
        console.log(error);
      }
    } else {
      push(`/${lang}/${RoutePaths.Login}`);
    }
  }, [query]);

  useEffectOnce(() => {
    onAcceptQuery();
  });

  return (
    <div className="w-full h-full">
      <LoadingPage />
    </div>
  );
};
